export default [{"url":"https://chiletest-0.api.invexerp.io","name":"Branch 1","port":"5048","isStore":true,"isHQ":true}]